
    __webpack_require__.initializeExposesData = {
  moduleMap: {
  "./Attendance": () => {
return Promise.all(/*  | __federation_expose_Attendance */ [__webpack_require__.e("787"), __webpack_require__.e("603"), __webpack_require__.e("810")]).then(() => (() => (__webpack_require__(8043))));
},
"./Leave": () => {
return Promise.all(/*  | __federation_expose_Leave */ [__webpack_require__.e("787"), __webpack_require__.e("603"), __webpack_require__.e("353"), __webpack_require__.e("270")]).then(() => (() => (__webpack_require__(5697))));
},
"./AttendanceMng": () => {
return Promise.all(/*  | __federation_expose_AttendanceMng */ [__webpack_require__.e("787"), __webpack_require__.e("603"), __webpack_require__.e("26"), __webpack_require__.e("80")]).then(() => (() => (__webpack_require__(5319))));
},
"./LeaveMng": () => {
return Promise.all(/*  | __federation_expose_LeaveMng */ [__webpack_require__.e("787"), __webpack_require__.e("603"), __webpack_require__.e("639"), __webpack_require__.e("180")]).then(() => (() => (__webpack_require__(2937))));
},
"./Messenger": () => {
return Promise.all(/*  | __federation_expose_Messenger */ [__webpack_require__.e("787"), __webpack_require__.e("603"), __webpack_require__.e("697"), __webpack_require__.e("542")]).then(() => (() => (__webpack_require__(5261))));
},
},
  shareScope: "default",
};
__webpack_require__.getContainer = __webpack_require__.getContainer || function() { throw new Error("should have __webpack_require__.getContainer") };__webpack_require__.initContainer = __webpack_require__.initContainer || function() { throw new Error("should have __webpack_require__.initContainer") };